define('views/modules/conversation/conversation-manager-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/viewport',
    'services/i18n',
    'services/events/conversation-events',
    // models & collections
    'collections/conversation/conversations',
    'models/conversation/conversation',
    // Views
    'views/parts/menu/menu-action',
    'views/parts/form/textbox',
    'views/modules/conversation/lists/conversation-list',
    'views/modules/member/select/member-select-panel',
    'views/parts/alert/alert-list',
    'views/modules/conversation/message/send-message-modal',
    // Templates Blocks
    'text!templates/modules/conversation/conversation-manager-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    Viewport,
    i18n,
    ConversationEvents,
    // models & collections
    CConversations,
    MConversation,
    // Views
    VMenuAction,
    VTextBox,
    VConversationList,
    VMemberSelectPanel,
    VAlertList,
    VSendMessageModal,
    // Template
    TConversationManagerContent
) {

    var VConversationManagerContent = Backbone.View.extend({
        template: TConversationManagerContent,

        // abstracting selectors out of the view logic
        regions: {
            root: "#conversation-manager-content",
            menu: ".menu-actions",
            alert: ".alert-list",
            search: ".search-placeholder",
            list: ".conversation-list"
        },

        initialize: function(opt) {
            this.options = opt = _.extend({
                folder: 'inbox'
            }, opt);

            this.setUrl('root', opt.url);

            _.extend(this, {
                group: opt.group,
                profile: this.model,
                collection: new CConversations(),
                folder: opt.folder,
                role: opt.role,
            });

            var collection = this.collection;
            if (opt.folder) {
                collection.setFolder(opt.folder);
            }

            var view = this.view = {
                menu: new VMenuAction({
                    context: this,
                    radio: false,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-new-conversation'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddConversationClick },
                        { id: "mark-all-as-read", title: i18n.t('messages:tooltip-mark-all-as-read'), icon: 'sl-icon-envelope-open', callback: this.onMarkAsRead, skipTranslation: 'true' },
                    ]),
                    onClick: this.onActionClick,
                    tooltip: {
                        container: this.regions.root,
                    }
                }),

                list: new VConversationList({
                    collection: collection,
                    title: false,
                    profile: this.profile,
                    folder: opt.folder,
                    bottom: true,
                }),
                alert: new VAlertList({
                    collection: new Backbone.Collection([
                        { type: 'info', message: 'messages:message-multiple-user-conversation', dismissable: true }
                    ])
                })
            };

            this.listenTo(collection, {
                'conversation:select': this.onSelectConversation,
                "sync": this.onConversationSync,
                "remove": this.onRemoveConversation,
                "update": this.onCollectionChanged,
            });

            this.collection.getFirstPage();
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                isInbox: this.isInbox()
            })));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

            return this;
        },

        resetList: function() {
            this.collection.trigger('reset');
        },

        isInbox: function() {
            return this.folder === 'inbox';
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddConversationClick: function() {
            var view = this.view.select;
            if (!view) {
                view = this.view.select = new VMemberSelectPanel({ group: this.group });
                this.listenTo(view, { 'selected:confirm': this.onSelectedConfirm });
            }
            this.trigger('panel:stack', view);
        },

        onMarkAsRead: function() {
            Bootbox.confirm({
                title: i18n.t("conversation:confirm_mark_all_as_read_title"),
                message: i18n.t("conversation:confirm_mark_all_as_read_message"),
                onEscape: true,
                backdrop: true,
                callback: this.onMarkAsReadConfirmed,
                context: this,
            });
        },

        onMarkAsReadConfirmed: function(result) {
            if (!result) return;

            var self = this,
                model = this.collection.models[0];

            this.collection.markAllAsRead({}).then(function() {
                ConversationEvents.markAllAsRead();

                self.render();
            });
        },

        ////////////
        // events //
        ////////////

        onQuerySubmit: function(model, value) {
            this.collection.setQuery(value).getFirstPage();
            this.resetList();
        },

        onSelectConversation: function(model, user) {
            model.setDistantMember(user.id);
            model.setAsRead();

            Backbone.history.navigate("#/" + Mustache.render(this.url.root + '{{conversationId}}/', {
                userId: this.role === 'client' ? 'me' : user.id,
                groupId: user.get('mainGroupId'),
                conversationId: model.id
            }));

            if (Viewport.isMobile()) {
                this.trigger('back');
            }

            ConversationEvents.clickConversation(model);
        },

        onRemoveConversation: function(model) {
            Backbone.history.navigate("#/" + Mustache.render(this.url.root, {
                userId: model.getUser().id,
                groupId: this.group.id,
            }));
        },

        onCollectionChanged: function(model) {
            this.render();
        },

        onSelectedConfirm: function(collection) {
            if (collection.length === 1) {
                var user = collection.first();
                Backbone.history.navigate("#/" + Mustache.render(this.url.root, {
                    userId: user.id,
                    groupId: user.getMainGroupId()
                }));

                ConversationEvents.userSelected();
            } else {
                var modal = this.view.message || (this.view.message = new VSendMessageModal({
                    callback: this.onSendSuccess,
                    context: this,
                    group: this.group
                }));
                modal.setSelectedUsers(collection)
                    .show();
            }
        },

        onSendSuccess: function(response) {
            this.collection.parse(response);
            this.collection.reset(response.collection, { sort: false });
        },

        onConversationSync: function(response) {
            var unreadCount = this.collection.getUnreadCount();
            var buttonView = _.find(this.view.menu.childViews, function(view) {
                return view.model.get('id') === "mark-all-as-read";
            });

            if (buttonView) {
                if (unreadCount <= 0) {
                    buttonView.toggleDisabled(true);
                } else {
                    buttonView.toggleDisabled(false);
                    ConversationEvents.clickConversation(response.models[1]);
                }
            }
        },

    });

    return VConversationManagerContent;

});

